// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mt-3";
export var downloadButton = "_mt-4";
export var fileContainer = "_mt-9 _mt-7";
export var fileContainerBase = "_mt-7";
export var fileContainerFixedHeight = "_mt-8 _mt-7";
export var fileInfo = "_mt-5";
export var fileInfoWidthRestricted = "_mt-6";
export var fileType = "_mt-1";
export var fileTypeName = "_mt-2";
export var image = "_mt-0";
export var link = "_mt-b";
export var overflowEllipsis = "_mt-a";